import { AnyAction, Dispatch } from 'redux'
import { NavigateFunction } from 'react-router-dom'
import { ManualRequestsService } from '../../services/myActionsService'
import { AbsenceDayDeleteRequest, AbsenceDeleteRequest } from '../../types/absence'
import { AbsenceDay } from '../../types/absence-day'
import { BaseResponse } from '../../types/base-response'
import { showErrorMessage, showSuccessMessage } from '../../redux/reducers/snackbarReducer'
import UserErrorMessage from '../../utils/errorFilter'
import { hideModal } from '../../redux/reducers/appSettingsReducer'

export const calcEmptyTableCell = (location: boolean, absenceReasonType: string | undefined) => {
  if (!location) {
    return
  }
  if (absenceReasonType === 'NoShow' || absenceReasonType === 'NonSickness') {
    return false
  }

  return true
}

export const isFormValid = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValidationErrors: (validationErrors: any) => void,
  deleteReason: string,
  deleteComment: string
) => {
  setValidationErrors({})
  const errors: any = {}
  if (deleteReason === '') {
    errors.deleteReason = true
  }
  if (deleteComment === '') {
    errors.deleteComment = true
  }
  if (Object.keys(errors).length !== 0) {
    setValidationErrors(errors)
    return false
  }
  return true
}

export const deleteAbsenceDay = (
  selectedRow: AbsenceDay | null,
  absenceId: number,
  deleteReason: string,
  deleteComment: string,
  absenceDays: AbsenceDay[],
  manualRequestsService: ManualRequestsService,
  dispatch: Dispatch<AnyAction>,
  onDelete: ((row: AbsenceDay) => void) | undefined,
  setDeleteComment: React.Dispatch<React.SetStateAction<string>>,
  navigate: NavigateFunction,
  returnTo: string
) => {
  if (!selectedRow) {
    return
  }

  const absenceBody: AbsenceDeleteRequest = {
    absenceId,
    deleteReason,
    deleteDescription: deleteComment,
  }

  const absenceDayBody: AbsenceDayDeleteRequest = {
    absenceDayId: selectedRow.id,
    deleteReason: String(deleteReason),
    deleteDescription: deleteComment,
  }

  if (absenceDays.length > 1) {
    manualRequestsService
      .deleteAbsenceDay(absenceDayBody)
      .then(res => {
        dispatch(showSuccessMessage('Absence day deleted successfully!'))
        dispatch(hideModal())
        onDelete?.(selectedRow)
        setDeleteComment('')
      })
      .catch(err => {
        const response: BaseResponse = err.response.data
        response.errors.forEach(error => {
          dispatch(showErrorMessage(<UserErrorMessage name={error.name} />))
        })
      })
  } else {
    manualRequestsService
      .deleteAbsenceOccurrence(absenceBody)
      .then(res => {
        dispatch(showSuccessMessage('Absence occurrence deleted successfully!'))
        dispatch(hideModal())
        navigate(returnTo)
      })
      .catch(err => {
        const response: BaseResponse = err.response.data
        response.errors.forEach(error => {
          dispatch(showErrorMessage(<UserErrorMessage name={error.name} />))
        })
      })
  }
}
